import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { config } from "../_helpers/global";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";
import { InterModularSidebar } from "../Layouts/InterModularSidebar";

export class cms extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      topbarcolour: "",
      leftbarcolour: "",
      footercolour: "",
      backendurl: "",
      sitetitle: "",
      allModuleData: "",
      backimg:""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onFileChange  = this.onFileChange .bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
  }
  
  onFileChange = event => {
 
    // Update the state
    this.setState({ backimg: event.target.files[0] });
    console.log(event.target.files[0])
    };




  componentDidMount() {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("patientVisitId"),
      "Content-Type": "multipart/form-data",
      // 'visitid': localStorage.getItem('visitId')
    };
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    console.log(this.state)
    axios
      .post(this.api_url+"chief/cms/settings", this.state, {
        headers: headers,
      })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => { 
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { topbarcolour, leftbarcolour, footercolour, backendurl, sitetitle } =
      this.state;

    const editdetailId = localStorage.getItem("editdetailId");
    return (
      <div>
        <Headers />
        <InterModularSidebar />
        <p className="dataEnetered"></p>

        <main className="content-container ">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit} encType="multipart/form-data">
              <div className="form-row pt-4 formSpace">
                <div className="col-md-12 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    CMS {editdetailId}
                  </p>
                </div>

                <div className="py-1">
                  <h6 className="text-capitalize" style={fontFamilyNunito}>
                    Topbar Colour
                  </h6>
                  <input
                    className="form-control"
                    onChange={this.handleChange}
                    value={topbarcolour}
                    name="topbarcolour"
                    type="text"
                    required
                  />
                </div>

                <div className="py-1">
                  <h6 className="text-capitalize" style={fontFamilyNunito}>
                    Leftbar Colour
                  </h6>
                  <input
                    className="form-control"
                    onChange={this.handleChange}
                    value={leftbarcolour}
                    name="leftbarcolour"
                    type="text"
                    required
                  />
                </div>

                <div className="py-1">
                  <h6 className="text-capitalize" style={fontFamilyNunito}>
                    Footer Colour
                  </h6>
                  <input
                    className="form-control"
                    onChange={this.handleChange}
                    value={footercolour}
                    name="footercolour"
                    type="text"
                    required
                  />
                </div>
                <div className="py-1">
                  <h6 className="text-capitalize" style={fontFamilyNunito}>
                    Backend Url
                  </h6>
                  <input
                    className="form-control"
                    onChange={this.handleChange}
                    value={backendurl}
                    name="backendurl"
                    type="text"
                    required
                  />
                </div>

                <div className="py-1">
                  <h6 className="text-capitalize" style={fontFamilyNunito}>
                    Site Title
                  </h6>
                  <input
                    className="form-control"
                    onChange={this.handleChange}
                    value={sitetitle}
                    name="sitetitle"
                    type="text"
                    required
                  />
                </div>
                <div className="py-1">
                  <h6 className="text-capitalize" style={fontFamilyNunito}>
                    Back image
                  </h6>
                <input type="file" class="form-control" name="backimg" onChange={this.onFileChange} />
              </div>

              {/* <button onClick={this.onFileUpload}>
                        Upload!
                    </button> */}
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong> Details Saved Successfully.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default cms;
